import { useEffect, useState } from 'react';
import { io, type Socket } from 'socket.io-client';

let socket: Socket | null = null;

export function getSocket(): Socket {
  if (!socket) {
    socket = io('/', {
      path: '/socket.io',
      auth: { token: localStorage.getItem('access_token') ?? '' },
      transports: ['websocket', 'polling'],
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionAttempts: 10,
    });
  }
  return socket;
}

export function joinInstitutionRoom(institutionId: string): void {
  getSocket().emit('join_institution', institutionId);
}

export function leaveInstitutionRoom(institutionId: string): void {
  getSocket().emit('leave_institution', institutionId);
}

export function disconnectSocket(): void {
  socket?.disconnect();
  socket = null;
}

export interface PickupEventPayload {
  type: string;
  studentId: string;
  studentName: string;
  collectorName: string;
  timestamp: string;
  audioChime: boolean;
}

/*
  Whether the live gate feed is actually up.

  Lifted out of DashboardPage so the command bar can show it on every screen.
  On this product that is operational information, not decoration: if the
  socket is down the board is stale, and someone reading it needs to know
  before they trust what it says about which children have left.
*/
export function useSocketStatus(): boolean {
  const [connected, setConnected] = useState(() => getSocket().connected);

  useEffect(() => {
    const s = getSocket();
    const onConnect = () => setConnected(true);
    const onDisconnect = () => setConnected(false);

    s.on('connect', onConnect);
    s.on('disconnect', onDisconnect);
    setConnected(s.connected);

    return () => {
      s.off('connect', onConnect);
      s.off('disconnect', onDisconnect);
    };
  }, []);

  return connected;
}
